export const eventsList = [
  {
    id: "e1",
    title: "风花节的回响",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20festival%20square%20filled%20with%20hanging%20lanterns%20and%20floating%20petals%2C%20warm%20amber%20and%20rose%20tones%2C%20joyful%20fantasy%20town%20celebration%2C%20painterly%20style&width=900&height=560&seq=event-cover-01&orientation=landscape",
    start: "2026-10-01",
    end: "2026-10-20",
    status: "ongoing",
    reward: "原石 ×1000、角色经验素材、摩拉 ×200000",
    intro: "一年一度的风花节再度开启，玩家可在节庆广场参与小游戏、收集花瓣并兑换限定奖励。",
    tips: [
      "每日完成三次委托可获得额外花瓣。",
      "节庆商店的限定摆设建议优先兑换。",
      "活动第三阶段解锁隐藏剧情，注意保留体力。",
    ],
    tags: ["限时活动", "节日", "福利"],
  },
  {
    id: "e2",
    title: "深境螺旋·本期挑战",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20ornate%20ancient%20arena%20with%20glowing%20elemental%20crystals%20and%20stone%20pillars%2C%20deep%20blue%20and%20amber%20lighting%2C%20mystical%20chamber%2C%20painterly%20fantasy%20style&width=900&height=560&seq=event-cover-02&orientation=landscape",
    start: "2026-10-01",
    end: "2026-10-15",
    status: "ongoing",
    reward: "原石 ×600、圣遗物、摩拉",
    intro: "本期深渊环境偏向元素反应增伤，十二层新增两名精英敌人，考验队伍的循环能力。",
    tips: [
      "上半优先使用水/火输出队伍。",
      "下半建议携带减抗辅助提升爆发。",
      "注意第十二层的元素护盾机制。",
    ],
    tags: ["深渊", "挑战", "战斗"],
  },
  {
    id: "e3",
    title: "「璃月远征」版本预热活动",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20misty%20mountain%20peaks%20with%20floating%20islands%20and%20ancient%20stone%20gates%2C%20cool%20teal%20and%20gold%20tones%2C%20epic%20adventure%20landscape%2C%20painterly%20fantasy%20style&width=900&height=560&seq=event-cover-03&orientation=landscape",
    start: "2026-10-11",
    end: "2026-11-05",
    status: "upcoming",
    reward: "原石 ×300、预约奖励、限定名片",
    intro: "新版本上线前的预热活动，完成每日任务累计进度即可在版本更新后领取限定奖励。",
    tips: [
      "活动进度全服共享，达到阶段目标即可解锁奖励。",
      "预约新版本可获得额外礼包。",
      "预热期间登录即可获得纪念名片。",
    ],
    tags: ["版本预热", "预约", "福利"],
  },
  {
    id: "e4",
    title: "提瓦特摄影大赛",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20scenic%20valley%20with%20waterfall%20and%20colorful%20flowers%2C%20golden%20hour%20lighting%2C%20peaceful%20fantasy%20landscape%2C%20painterly%20style&width=900&height=560&seq=event-cover-04&orientation=landscape",
    start: "2026-09-20",
    end: "2026-10-05",
    status: "ended",
    reward: "原石 ×420、纪念称号、限定喷漆",
    intro: "以提瓦特风景为主题的摄影活动，玩家可投稿作品参与评选，优秀作品将展示在官方社区。",
    tips: [
      "投稿作品需为游戏内截图。",
      "每人最多可投稿三张作品。",
      "评选结果将在活动结束后一周公布。",
    ],
    tags: ["社区", "摄影", "创作"],
  },
  {
    id: "e5",
    title: "限时双倍掉落周",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20glowing%20treasure%20chests%20and%20crystal%20shards%20on%20an%20ancient%20stone%20altar%2C%20warm%20golden%20light%2C%20mystical%20treasure%20concept%2C%20painterly%20fantasy%20style&width=900&height=560&seq=event-cover-05&orientation=landscape",
    start: "2026-10-18",
    end: "2026-10-25",
    status: "upcoming",
    reward: "天赋培养素材双倍、武器突破素材双倍",
    intro: "活动期间完成指定秘境挑战可获得双倍素材掉落，是集中培养角色的好机会。",
    tips: [
      "双倍次数每日有限，建议优先刷取稀缺素材。",
      "提前准备好原粹树脂以充分利用活动。",
      "可搭配经验加成食物提升效率。",
    ],
    tags: ["养成", "双倍", "福利"],
  },
  {
    id: "e6",
    title: "尘歌壶设计征集",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20serene%20teapot%20garden%20with%20bonsai%20trees%20and%20stone%20path%2C%20soft%20green%20and%20warm%20beige%20tones%2C%20peaceful%20fantasy%20garden%2C%20painterly%20style&width=900&height=560&seq=event-cover-06&orientation=landscape",
    start: "2026-09-10",
    end: "2026-09-30",
    status: "ended",
    reward: "原石 ×500、限定摆设蓝图",
    intro: "面向全体玩家的家园设计征集活动，分享你的尘歌壶布局，有机会获得限定奖励。",
    tips: [
      "投稿需附上至少三张不同角度的截图。",
      "原创设计优先评选。",
      "获奖作品将收录至官方设计图鉴。",
    ],
    tags: ["家园", "创作", "社区"],
  },
];